/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Email_LabelInputs */

const en_business_form_email_label = /** @type {(inputs: Business_Form_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work Email`)
};

const es_business_form_email_label = /** @type {(inputs: Business_Form_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de trabajo`)
};

/**
* | output |
* | --- |
* | "Work Email" |
*
* @param {Business_Form_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_email_label = /** @type {((inputs?: Business_Form_Email_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Email_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_email_label(inputs)
	return en_business_form_email_label(inputs)
});